import { fetchUser, user } from '@/ui/auth/auth';
import { useTask } from '@/ui/concerns';
import { updateIntercomTourShown } from '@/services/api/auth';
import * as Intercom from '@/services/intercom/intercom';
import { flow } from 'fp-ts/function';
import { parseInt10 } from '@/ui/helpers';
import { locales } from '@/ui/i18n/i18n';
import { ref } from 'vue';

export enum TourTypes {
  checklist = 'checklist'
}

export const useIntercomTour = () => {
  const localeTourMap: Record<TourTypes, Record<string, string>> = {
    checklist: {
      en: '168489',
      de: '182165',
      es: '189889',
    },
  };

  function getLocaleTourId(tourType: TourTypes, locale: locales) {
    return localeTourMap[tourType] ? localeTourMap[tourType][locale] ?? localeTourMap[tourType].en : null;
  }

  const tourId = ref<string | null>();

  //maybe we will need to store one type with all languages ids in the future
  const updateIntercom = (tourIdParam: string) => useTask(
    () => updateIntercomTourShown(tourIdParam),
    async () => {
      await fetchUser()();
    },
  );

  const runTourShow = flow(
    (tourIdParam: string) => {
      Intercom.startTour(tourIdParam);
      return tourIdParam;
    },
    //update user to not show it anymore
    (tourIdParam: string) => updateIntercom(tourIdParam).run(),
  );

  //string or number - always mixed from BE ...
  const userHaveSeenTheTour = (tourIdParam: string) => user.value.shownTours.includes(tourIdParam)
    || user.value.shownTours.includes(parseInt10(tourIdParam));

  const showTour = (tourType: TourTypes, locale: locales) => {
    if (process.env.VUE_APP_INTERCOM_ENABLED !== 'true') {
      return;
    }

    tourId.value = getLocaleTourId(tourType, locale);
    if (!tourId.value) {
      return;
    }

    if (userHaveSeenTheTour(tourId.value)) {
      return;
    }

    runTourShow(tourId.value);
  };

  return {
    showTour,
  };
};
